'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEvent = exports.openStandardDeposit = exports.complete3DS = exports.init3DSv2 = exports.init3DS = exports.closeComponent = exports.closingComponent = exports.restartDeposit = exports.performDepositFailed = exports.performApayDepositSucceded = exports.performDepositSucceded = exports.performDeposit = exports.fetchPmtMethodsFailed = exports.fetchPmtMethodsSucceded = exports.fetchPmtMethods = exports.updatePlayerSetAmount = exports.updateQuickDepositInitData = exports.configReceived = exports.openReceived = exports.setApplePayAvailability = undefined;

var _quickDepositLogic = require('@wh/quick-deposit-logic');

var _constants = require('./constants');

var setApplePayAvailability = exports.setApplePayAvailability = function setApplePayAvailability(availability) {
  return {
    type: _constants.QD_ACTION_SET_IS_APPLE_PAY_AVAILABLE,
    availability: availability
  };
};

var openReceived = exports.openReceived = function openReceived(config) {
  return {
    type: _constants.QD_ACTION_OPEN_RECEIVED,
    config: config
  };
};

var configReceived = exports.configReceived = function configReceived(config) {
  return {
    type: _constants.QD_ACTION_CONFIG_RECEIVED,
    config: config
  };
};

var updateQuickDepositInitData = exports.updateQuickDepositInitData = function updateQuickDepositInitData(payload) {
  return {
    type: _constants.QD_ACTION_UPDATE_INIT_DATA,
    payload: payload
  };
};

var updatePlayerSetAmount = exports.updatePlayerSetAmount = function updatePlayerSetAmount(hasPlayerSetAmount) {
  return {
    type: _constants.QD_ACTION_SET_PLAYER_AMOUNT,
    payload: hasPlayerSetAmount
  };
};

var fetchPmtMethods = exports.fetchPmtMethods = function fetchPmtMethods() {
  return {
    type: _constants.QD_ACTION_FETCH_PMT_METHODS
  };
};

var fetchPmtMethodsSucceded = exports.fetchPmtMethodsSucceded = function fetchPmtMethodsSucceded(pmtMethod, pmtData) {
  return {
    type: _constants.QD_ACTION_FETCH_PMT_METHODS_SUCCEDED,
    pmtMethod: pmtMethod,
    pmtData: pmtData
  };
};

var fetchPmtMethodsFailed = exports.fetchPmtMethodsFailed = function fetchPmtMethodsFailed(error) {
  return {
    type: _constants.QD_ACTION_FETCH_PMT_METHODS_FAILED,
    error: error
  };
};

var performDeposit = exports.performDeposit = function performDeposit(depositData) {
  return {
    type: _constants.QD_ACTION_PERFORM_DEPOSIT,
    depositData: depositData
  };
};

var performDepositSucceded = exports.performDepositSucceded = function performDepositSucceded(result) {
  return {
    type: _constants.QD_ACTION_PERFORM_DEPOSIT_SUCCEDED,
    result: result
  };
};

var performApayDepositSucceded = exports.performApayDepositSucceded = function performApayDepositSucceded(result) {
  return {
    type: _constants.QD_ACTION_PERFORM_APAY_DEPOSIT_SUCCEDED,
    result: result
  };
};

var performDepositFailed = exports.performDepositFailed = function performDepositFailed(error) {
  return {
    type: _constants.QD_ACTION_PERFORM_DEPOSIT_FAILED,
    error: error
  };
};

var restartDeposit = exports.restartDeposit = function restartDeposit() {
  return {
    type: _constants.QD_ACTION_RESTART_DEPOSIT
  };
};

var closingComponent = exports.closingComponent = function closingComponent() {
  var preventEventTriggering = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    type: _constants.QD_ACTION_CLOSING,
    preventEventTriggering: preventEventTriggering
  };
};

var closeComponent = exports.closeComponent = function closeComponent() {
  return {
    type: _constants.QD_ACTION_CLOSED
  };
};

var init3DS = exports.init3DS = function init3DS(data) {
  return {
    type: _constants.QD_ACTION_INIT3DS,
    data: data
  };
};

var init3DSv2 = exports.init3DSv2 = function init3DSv2(data) {
  return {
    type: _constants.QD_ACTION_INIT3DS_V2,
    data: data
  };
};

var complete3DS = exports.complete3DS = function complete3DS(data) {
  return {
    type: _constants.QD_ACTION_COMPLETE3DS,
    data: data
  };
};

var openStandardDeposit = exports.openStandardDeposit = function openStandardDeposit() {
  return {
    type: _constants.QD_ACTION_OPEN_STANDARD_DEPOSIT
  };
};

var trackEvent = exports.trackEvent = function trackEvent(event) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: _constants.QD_ACTION_TRACKING_EVENT,
    event: event,
    payload: payload
  };
};